import { Injectable, Inject } from '@angular/core';
import { SsoOptions } from './sso-options';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SsoOptionsService {
  private _options: SsoOptions;
  /**
   * Stores and serves redirection flag.
   * Defined on SsoOptionsService due to issue with multiple interceptor instances.
   */
  private _alreadyRedirected: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(@Inject('SsoOptions') private ssoOptions: SsoOptions) {
    this._options = this.ssoOptions;
  }

  get options() {
    return this._options;
  }

  get alreadyRedirected() {
    return this._alreadyRedirected.getValue();
  }

  set alreadyRedirected(val: boolean) {
    this._alreadyRedirected.next(val);
  }
}
